import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const InsightList = () => {
  const [viewType, setViewType] = useState('list'); // 'list' | 'grid'

  const toggleView = () => {
    setViewType(prev => (prev === 'list' ? 'grid' : 'list'));
  };

  const insightItems = [
    { name: 'Booking Details', link: 'bookingDetails' },
    { name: 'Client Reports', link: 'clientReport' },
    { name: 'Team Reports', link: 'teamReport' },
    { name: 'Services', link: 'serviceReport' },
    { name: 'Rush Hours', link: 'rushHours' },
    { name: 'Feedback', link: 'feedBack' },
    { name: 'Demographics', link: 'demoGraphics' },
    { name: 'Combo Reports', link: 'combo-report' },
    { name: 'Combo Package Reports', link: 'combo-package-report' },
    { name: 'Promotional Messages', link: 'promotionalMessage' },
    { name: 'Commissions', link: 'commission' }
  ];

  return (
    <section>
      <div className="m-t-3 cus-padd cusheight">

        {/* HEADER */}
        <header className="d-flex justify-content-between align-items-center">
          <h2 className="page-tittle">Insights</h2>

          <i
            className={`fa-solid ${viewType === 'list' ? 'fa-table-cells' : 'fa-list'}`}
            style={{ cursor: 'pointer', fontSize: 18 }}
            title="Toggle View"
            onClick={toggleView}
          />
        </header>

        <hr />

        {/* LIST / GRID (SINGLE MARKUP) */}
        <ul className={`cus-list ${viewType === 'grid' ? 'grid-view' : ''}`}>
          {insightItems.map(item => (
            <li key={item.link}>
              <NavLink to={item.link}>
                <div className="d-flex justify-content-between align-items-center">
                  <span>{item.name}</span>
                  <i className="fa-solid fa-angle-right"></i>
                </div>
              </NavLink>
            </li>
          ))}
        </ul>

      </div>
    </section>
  );
};

export default InsightList;
